import { render, staticRenderFns } from "./_content_overview.vue?vue&type=template&id=56e67af2&"
import script from "./_content_overview.vue?vue&type=script&lang=js&"
export * from "./_content_overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports